import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
// import Contact from "./Pages/Contact";
import Projects from "./Pages/Projects";
import Publications from "./Pages/Publication";
import Monologue from "./Pages/Monologue";
function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/monologue" element={<Monologue />} />
      </Routes>
      <Footer />
    </Router>
  );
}
export default App;
